import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouteService } from './services/route.service';
import { RouterNamedLink, RouterNamedLinkWithHref } from './directives/router-named-link';
import { RouterNamedLinkActive } from './directives/router-named-link-active';

@NgModule({
    imports: [],
    declarations: [
        RouterNamedLink,
        RouterNamedLinkActive,
        RouterNamedLinkWithHref
    ],
    providers: [],
    exports: [
        RouterNamedLink,
        RouterNamedLinkActive,
        RouterNamedLinkWithHref
    ]
})
export class RoutingModule {

    constructor() {
        console.log('Routing module constructed');
    }

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: RoutingModule,
            providers: [
                RouteService
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/routing/routing.module.ts